//Analytics

analytics.eventConfig.push({
    "target": "div.surfaceOverlayCollection",
    "codeId": "s01",
    "events": [
        {
            "eventTarget": ".surfaceOverlay-btn a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "s01",
                "componentName": "surface item",
                "elementText": "",
                "destinationUrl": "",
                "event": "navigation",
                "eventType": "surface item internal navigation click",
                "elementType": [
                    {
                        "rule": "$(context).hasClass('modal-btn')=== true",
                        "value": "surface item button"
                    },
                    {
                        "rule": "true",
                        "value": "surface item link"
                    }
                ],
                "fileName": "",
                "parentName": "surface overlay collection",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        }
    ]
})